import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss']
})
export class RadioButtonComponent implements OnInit {
  @Input() userForm;
  @Input() configValue;
  @Output() toggleContainer: EventEmitter<any> = new EventEmitter();
  constructor() { }

  ngOnInit() {
  }
  buttonClick = (ev, btn) => {
   // //console.log('btn', btn);
    ////console.log(this.configValue);
    this.configValue.forEach(config => {
      config.isActive = false;
    });
    btn.isActive = true;
    this.toggleContainer.emit(btn);
    // this.messageService.sendButtonStatus(btn);
  }
}
